module.exports = __webpack_public_path__ + "img/print_v@2x.58ea915d.png";